<div class="min-h-screen bg-gray-50/50 p-6 md:p-12 md:pt-8 font-sans">

    <!-- Header Section -->
    <div class="max-w-7xl mx-auto mb-8">
        <a routerLink="/home"
            class="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-gray-800 transition mb-4 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m15 18-6-6 6-6" />
            </svg>
            Back to Home
        </a>

        <div class="flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
            <div>
                <h1 class="text-3xl font-extrabold text-[#0C447D] tracking-tight">Outstanding Payments</h1>
                <p class="text-gray-500 mt-2">Comprehensive list of all customer cash and metal liabilities.</p>
            </div>

            <!-- Quick Stats -->
            <div class="flex gap-4">
                <div class="bg-white px-5 py-3 rounded-xl border border-gray-100 shadow-sm">
                    <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest">Total Cash Due</p>
                    <p class="text-xl font-extrabold text-red-600">₹{{ totalOutstandingCash | number:'1.2-2' }}</p>
                </div>
                <div class="bg-white px-5 py-3 rounded-xl border border-gray-100 shadow-sm">
                    <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest">Total Metal Due</p>
                    <p class="text-xl font-extrabold text-amber-600">{{ totalOutstandingMetal | number:'1.3-3' }} <small
                            class="text-xs">gm</small></p>
                </div>
                <div class="bg-white px-5 py-3 rounded-xl border border-gray-100 shadow-sm" *ngIf="criticalCount > 0">
                    <p class="text-[10px] text-red-400 font-bold uppercase tracking-widest">Critical Accounts</p>
                    <div class="flex items-center gap-2">
                        <span class="w-2 h-2 bg-red-500 rounded-full animate-ping"></span>
                        <p class="text-xl font-extrabold text-gray-800">{{ criticalCount }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Main Table Card -->
    <div class="max-w-7xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">

        <!-- Table Header -->
        <div class="px-6 py-4 border-b border-gray-100 bg-[#F1F8FF] flex justify-between items-center">
            <h3 class="font-bold text-[#0C447D] text-sm flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                Active Debtor List
            </h3>
            <div class="flex gap-2">
                <button (click)="exportToExcel()"
                    class="px-3 py-1.5 bg-white border border-gray-200 text-gray-600 text-xs font-bold rounded-lg hover:bg-gray-50 transition-colors">Export
                    Excel</button>
                <button (click)="exportToPDF()"
                    class="px-3 py-1.5 bg-[#0C447D] text-white text-xs font-bold rounded-lg hover:bg-[#093461] shadow-lg shadow-blue-100 transition-colors">Export
                    PDF</button>
            </div>
        </div>

        <!-- Filter Bar -->
        <div class="px-6 py-3 border-b border-gray-50 bg-white flex flex-wrap gap-4 items-center">
            <!-- Search -->
            <div class="relative flex-1 min-w-[200px]">
                <input type="text" [(ngModel)]="filterName" (input)="applyFilters()"
                    placeholder="Search by customer name..."
                    class="w-full pl-9 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 transition-all">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 absolute left-3 top-2.5 text-gray-400"
                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>

            <!-- From Date -->
            <div class="flex items-center gap-2">
                <span class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">From</span>
                <input type="date" [(ngModel)]="fromDate" (change)="applyFilters()"
                    class="px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-lg text-xs font-medium focus:outline-none focus:border-blue-400">
            </div>

            <!-- To Date -->
            <div class="flex items-center gap-2">
                <span class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">To</span>
                <input type="date" [(ngModel)]="toDate" (change)="applyFilters()"
                    class="px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-lg text-xs font-medium focus:outline-none focus:border-blue-400">
            </div>

            <!-- Reset -->
            <button (click)="resetFilters()"
                class="px-5 py-2 text-blue-600 hover:bg-blue-50 rounded-xl text-[10px] font-bold uppercase tracking-widest transition-all">
                Reset Filters
            </button>
        </div>

        <!-- Advanced Property Filters (Range) -->
        <div class="px-6 py-6 border-b border-gray-50 bg-[#F9FBFF]/50 grid grid-cols-1 md:grid-cols-2 gap-8">
            <!-- Cash Balance Range -->
            <div class="flex flex-col gap-3">
                <div class="flex items-center gap-2">
                    <div class="w-1.5 h-1.5 rounded-full bg-blue-500 shadow-[0_0_8px_rgba(59,130,246,0.5)]"></div>
                    <label class="text-[10px] font-extrabold text-gray-500 uppercase tracking-widest">Amount Range
                        (₹)</label>
                </div>
                <div class="flex items-center gap-3">
                    <div class="relative flex-1 group">
                        <span
                            class="absolute left-3.5 top-1/2 -translate-y-1/2 text-[9px] font-extrabold text-gray-400 group-focus-within:text-blue-500 transition-colors">MIN</span>
                        <input type="number" [(ngModel)]="minCash" (ngModelChange)="applyFilters()" placeholder="0.00"
                            class="w-full pl-12 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm font-bold text-gray-700 focus:outline-none focus:ring-4 focus:ring-blue-100/50 focus:border-blue-400/50 transition-all placeholder:text-gray-200 shadow-sm">
                    </div>
                    <div class="w-2.5 h-[2px] bg-gray-200 rounded-full"></div>
                    <div class="relative flex-1 group">
                        <span
                            class="absolute left-3.5 top-1/2 -translate-y-1/2 text-[9px] font-extrabold text-gray-400 group-focus-within:text-blue-500 transition-colors">MAX</span>
                        <input type="number" [(ngModel)]="maxCash" (ngModelChange)="applyFilters()" placeholder="ANY"
                            class="w-full pl-12 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm font-bold text-gray-700 focus:outline-none focus:ring-4 focus:ring-blue-100/50 focus:border-blue-400/50 transition-all placeholder:text-gray-200 shadow-sm">
                    </div>
                </div>
            </div>

            <!-- Metal Balance Range -->
            <div class="flex flex-col gap-3">
                <div class="flex items-center gap-2">
                    <div class="w-1.5 h-1.5 rounded-full bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.5)]"></div>
                    <label class="text-[10px] font-extrabold text-gray-500 uppercase tracking-widest">Metal Range
                        (gm)</label>
                </div>
                <div class="flex items-center gap-3">
                    <div class="relative flex-1 group">
                        <span
                            class="absolute left-3.5 top-1/2 -translate-y-1/2 text-[9px] font-extrabold text-gray-400 group-focus-within:text-amber-500 transition-colors">MIN</span>
                        <input type="number" [(ngModel)]="minMetal" (ngModelChange)="applyFilters()" placeholder="0.000"
                            class="w-full pl-12 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm font-bold text-gray-700 focus:outline-none focus:ring-4 focus:ring-amber-100/50 focus:border-amber-400/50 transition-all placeholder:text-gray-200 shadow-sm">
                    </div>
                    <div class="w-2.5 h-[2px] bg-gray-200 rounded-full"></div>
                    <div class="relative flex-1 group">
                        <span
                            class="absolute left-3.5 top-1/2 -translate-y-1/2 text-[9px] font-extrabold text-gray-400 group-focus-within:text-amber-500 transition-colors">MAX</span>
                        <input type="number" [(ngModel)]="maxMetal" (ngModelChange)="applyFilters()" placeholder="ANY"
                            class="w-full pl-12 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm font-bold text-gray-700 focus:outline-none focus:ring-4 focus:ring-amber-100/50 focus:border-amber-400/50 transition-all placeholder:text-gray-200 shadow-sm">
                    </div>
                </div>
            </div>
        </div>

        <div class="overflow-x-auto">
            <table class="w-full text-left border-collapse">
                <thead>
                    <tr
                        class="bg-gray-50/50 border-b border-gray-100 text-[10px] uppercase tracking-widest text-[#0C447D] font-bold">
                        <th class="px-6 py-5">Client Information</th>
                        <th class="px-6 py-5">Location</th>
                        <th class="px-6 py-5 text-right cursor-pointer group/sort" (click)="toggleSort('metal_due')">
                            <div class="flex items-center justify-end gap-1">
                                Metal Due (gm)
                                <svg [class.opacity-100]="sortKey === 'metal_due'"
                                    class="w-3.5 h-3.5 opacity-0 group-hover/sort:opacity-50 transition-opacity duration-200"
                                    [class.rotate-180]="sortKey === 'metal_due' && sortDirection === 'asc'"
                                    fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                        </th>
                        <th class="px-6 py-5 text-right cursor-pointer group/sort" (click)="toggleSort('cash_due')">
                            <div class="flex items-center justify-end gap-1">
                                Pending Amount (₹)
                                <svg [class.opacity-100]="sortKey === 'cash_due'"
                                    class="w-3.5 h-3.5 opacity-0 group-hover/sort:opacity-50 transition-opacity duration-200"
                                    [class.rotate-180]="sortKey === 'cash_due' && sortDirection === 'asc'"
                                    fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                        </th>
                        <th class="px-6 py-5 text-center">Last Activity</th>
                        <th class="px-6 py-5 text-center">Actions</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-50">
                    <!-- Loading State -->
                    <tr *ngIf="isLoading">
                        <td colspan="6" class="px-6 py-20 text-center">
                            <div class="flex flex-col items-center gap-4">
                                <div
                                    class="w-10 h-10 border-4 border-[#0C447D] border-t-transparent rounded-full animate-spin">
                                </div>
                                <span class="text-sm text-gray-500 font-medium tracking-wide">Syncing account
                                    data...</span>
                            </div>
                        </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="!isLoading && filteredDebtors.length === 0">
                        <td colspan="6" class="px-6 py-20 text-center">
                            <div class="flex flex-col items-center gap-4">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 text-gray-200" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                <span class="text-gray-400 italic font-medium">No debtors found matching your
                                    criteria.</span>
                            </div>
                        </td>
                    </tr>

                    <!-- Data Rows -->
                    <tr *ngFor="let client of paginatedDebtors"
                        class="group hover:bg-blue-50/30 transition-colors duration-200">

                        <!-- Client Profile -->
                        <td class="px-6 py-4">
                            <div class="flex items-center gap-4">
                                <div
                                    class="w-9 h-9 rounded-xl bg-blue-100 flex items-center justify-center text-[11px] font-extrabold text-[#0C447D] border border-blue-200">
                                    {{ client.initials }}
                                </div>
                                <div class="flex flex-col">
                                    <span
                                        class="font-extrabold text-gray-800 text-sm group-hover:text-[#0C447D] transition-colors leading-tight">{{
                                        client.name }}</span>
                                    <span class="text-[10px] text-gray-400 font-bold uppercase tracking-tighter">{{
                                        client.mobile }}</span>
                                </div>
                            </div>
                        </td>

                        <!-- Location -->
                        <td class="px-6 py-4">
                            <div class="flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-gray-400" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <span class="text-xs text-gray-600 font-semibold">{{ client.location }}</span>
                            </div>
                        </td>

                        <!-- Metal Due -->
                        <td class="px-6 py-4 text-right">
                            <span class="font-mono text-sm font-bold" [class.text-amber-600]="client.metal_due > 0">
                                {{ client.metal_due | number:'1.3-3' }} <small
                                    class="text-[10px] text-gray-400 font-bold font-sans uppercase">gm</small>
                            </span>
                        </td>

                        <!-- Amount -->
                        <td class="px-6 py-4 text-right">
                            <p class="font-mono text-base font-extrabold" [class.text-red-600]="client.cash_due > 0">
                                ₹{{ client.cash_due | number:'1.2-2' }}
                            </p>
                        </td>

                        <!-- Last Activity -->
                        <td class="px-6 py-4 text-center">
                            <span class="text-[11px] font-bold text-gray-500 uppercase tracking-tight">
                                {{ client.last_date ? (client.last_date | date:'dd MMM yyyy') : 'N/A' }}
                            </span>
                        </td>

                        <td class="px-6 py-4 text-center">
                            <button (click)="payUdhar(client.id)"
                                class="px-3 py-1.5 bg-[#0C447D] text-white text-[10px] font-bold rounded-lg hover:bg-[#093461] transition-colors uppercase tracking-widest shadow-md shadow-blue-100">
                                Pay Udhar
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Footer Pagination -->
        <div class="bg-gray-50/50 px-6 py-4 border-t border-gray-100 flex flex-wrap justify-between items-center gap-4">

            <!-- Rows per page selection -->
            <div class="flex items-center gap-4">
                <div class="flex items-center gap-2">
                    <label class="text-[10px] font-extrabold text-gray-400 uppercase tracking-widest">Rows:</label>
                    <select [(ngModel)]="itemsPerPage" (change)="currentPage=1; updatePagination()"
                        class="bg-white border border-gray-200 rounded-xl px-2 py-1.5 text-[11px] font-bold text-[#0C447D] focus:outline-none focus:ring-4 focus:ring-blue-100/50 focus:border-blue-400/50 transition-all cursor-pointer">
                        <option [value]="5">5</option>
                        <option [value]="10">10</option>
                        <option [value]="20">20</option>
                        <option [value]="50">50</option>
                        <option [value]="100">100</option>
                    </select>
                </div>
                <span class="text-[10px] font-extrabold text-gray-300 uppercase tracking-widest">
                    Page {{ currentPage }} of {{ totalPages }} ({{ filteredDebtors.length }} items)
                </span>
            </div>

            <!-- Numbered Pagination -->
            <div class="flex items-center gap-2">
                <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
                    class="w-8 h-8 flex items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 hover:bg-gray-50 transition-all disabled:opacity-20 disabled:cursor-not-allowed group">
                    <svg xmlns="http://www.w3.org/2000/svg"
                        class="w-3.5 h-3.5 group-hover:-translate-x-0.5 transition-transform" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7" />
                    </svg>
                </button>

                <div class="flex gap-1.5">
                    <ng-container *ngFor="let page of pageNumbers">
                        <button *ngIf="page !== '...'; else ellipsis" (click)="goToPage(page)"
                            [class]="currentPage === page ? 'bg-[#0C447D] text-white border-[#0C447D] shadow-[0_4px_12px_rgba(12,68,125,0.25)] scale-110' : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50 hover:border-gray-300'"
                            class="min-w-[32px] h-8 px-2 flex items-center justify-center rounded-xl border text-[11px] font-bold transition-all duration-200">
                            {{ page }}
                        </button>
                        <ng-template #ellipsis>
                            <span class="w-8 h-8 flex items-center justify-center text-gray-300 font-bold">...</span>
                        </ng-template>
                    </ng-container>
                </div>

                <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
                    class="w-8 h-8 flex items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 hover:bg-gray-50 transition-all disabled:opacity-20 disabled:cursor-not-allowed group">
                    <svg xmlns="http://www.w3.org/2000/svg"
                        class="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>